const normalizePath = (value?: string): string => {
  const raw = String(value || '').trim();
  if (!raw) return '/';
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
  return raw.startsWith('/') ? raw : `/${raw}`;
};

export const adminPath = (value?: string): string => normalizePath(value);

